import * as types from '../types'
import { Images } from '../../helpers';

export const accgetImageWithProperty =  (id) => async (dispatch, getState) => {
   let resp = await Images.fetchCreateImage(id);
   if(resp && resp.status){
      console.log(resp);
      dispatch(GetImageWithProperty(resp.created_image));
   }
}

export const saveAllImageProperties =  () => async (dispatch, getState) => {
   const imageWithProperties = getState().image;
   let resp = await Images.saveImageWithProperties(imageWithProperties);
   if(resp){
      console.log(resp);
      // dispatch(LoadingToggle(false));
      // dispatch(GetImageWithProperty(resp.created_image));
      // Alerts.alertMessage('Data Saved successfully', '', 'success','',1000)
   }
  
}

export const removeImageProperty =  (id) => async (dispatch, getState) => {
   let resp = await Images.removeImageProperty(id);
   if(resp){
    dispatch(RemoveImageProperty(id))
   }
}

/*GetImageWithProperty*/
export function GetImageWithProperty(payload){
 
      return{
         type:types.GET_IMAGE_WITH_PROPERTY,
         payload
     }
  
 
}
export function AddImageProperty(payload){
   return {
       type:types.ADD_IMAGE_PROPERTY,
       payload
   }
}
export function RemoveImageProperty(payload){
   return {
       type:types.REMOVE_IMAGE_PROPERTY,
       payload
   }
}

export function LoadingToggle(payload){
   return {
       type:types.TOGGLE_LOADING,
       payload
   }
}
export function UpdatePropertyText(payload){
   return {
       type:types.UPDATE_PROPERTY_TEXT,
       payload
   }
}
export function UpdateTextAreaSize(payload){
   return {
       type:types.UPDATE_TEXTAREA_SIZE,
       payload
   }
}
export function UpdateImageSize(payload){
   return {
       type:types.UPDATE_IMAGE_SIZE,
       payload
   }
}
export function UpdatePhotoHolderSize(payload){
   return {
       type:types.UPDATE_PHOTO_HOLDER_SIZE,
       payload
   }
}

export function UpdateFontFamily(payload){
   return {
       type:types.UPDATE_FONT_FAMILY,
       payload
   }
}

export function UpdateFontSize(payload){
   return {
       type:types.UPDATE_FONT_SIZE,
       payload
   }
}
export function UpdateLineHeight(payload){
   return {
       type:types.UPDATE_LINE_HEIGHT,
       payload
   }
}

export function UpdateFontColor(payload){
   return {
       type:types.UPDATE_FONT_COLOR,
       payload
   }
}
export function UpdateBackgroundColor(payload){
   return {
       type:types.UPDATE_BACKGROUND_COLOR,
       payload
   }
}
export function UpdateBoxRotation(payload){
   return {
       type:types.UPDATE_BOX_ROTATION,
       payload
   }
}
export function UpdateTextStroke(payload){
   return {
       type:types.UPDATE_TEXT_STROKE,
       payload
   }
}

export function UpdateLetterSpacing(payload){
   return {
       type:types.UPDATE_LETTER_SPACING,
       payload
   }
}

export function UpdateTextAlignment(payload){
   return {
       type:types.UPDATE_TEXT_ALIGNMENT,
       payload
   }
}

export function UpdatePropertyTranslation(payload){
   return {
       type:types.UPDATE_PROPERTY_TRANSLATION,
       payload
   }
}
export function UpdatePhoto(payload){
   return {
       type:types.UPDATE_PHOTO,
       payload
   }
}
export function removePhoto(payload){
   return {
       type:types.REMOVE_PHOTO,
       payload
   }
}

// export function UpdatePropertyTranslation(payload){
//    return {
//        type:types.UPDATE_PROPERTY_TRANSLATION,
//        payload
//    }
// }




